import axios from 'axios';
import { V1_API_URL_PREFIX } from '../Constants';

class UserService {

    retrieveAllUsers() {
        return axios.get(`${V1_API_URL_PREFIX}/users `);
    }
}

export default new UserService()